import React from 'react';
import {render} from "react-dom";
import UserList from "v4/components/form/Field/components/InputRichText/plugins/ActionTag/components/UserList/UserList";
import {
    renderEditorActionTag
} from "v4/components/form/Field/components/InputRichText/plugins/ActionTag/utils/actionTagUtils";

/**
 * Init the action tag plugin
 * @param {import("tinymce/tinymce").Editor} editor
 * @param {string} fieldName
 * @param {Object} prospect
 * @param {Array} tags
 *
 * @returns {import("tinymce/tinymce").Plugin}
 */
export default function initActionTag(editor, fieldName, prospect, tags = []) {
    let canUseKeyboard = true;
    const toggleCanUseKeyboard = (forceBool) => canUseKeyboard = forceBool ?? !canUseKeyboard;

    editor.on('keydown', async (event) => {
        if (!canUseKeyboard) {
            event.preventDefault();
            return;
        }

        if (event.key === '@' && editor.getContainer()) {
            toggleCanUseKeyboard(false);
            const userListContainer = document.createElement('div');
            userListContainer.classList.add('user-list__container');
            editor.getContainer().after(userListContainer);

            // Génère un rendu de liste pour la sélection d'un utilisateur
            render(
                <UserList editor={editor} toggleCanUseKeyboard={toggleCanUseKeyboard} prospect={prospect}/>,
                userListContainer
            );
        } else {
            toggleCanUseKeyboard(true);
        }
    });

    const renderActionTagsInContent = () => {
        editor.getBody().querySelectorAll('[data-role="editor-action-tag"]').forEach(tagElement => {
            const tagInfos = tags.find(tag => tag.id === tagElement.dataset.tagId) ?? {};
            renderEditorActionTag(tagElement, tagInfos);
        });
    }

    editor.on('SetContent', () => {
        renderActionTagsInContent();

        // If the user tag label is not inside a user tag, we replace it with the text only
        const orphanLabels = editor.getBody().querySelectorAll(':not(.user-tag) > .user-tag-label');
        orphanLabels.forEach(label => label.outerHTML = label.innerText);
    });

    editor.on('LoadContent', () => {
        renderActionTagsInContent();
    });

    // Prevent the cursor to be stuck in the user-tag
    editor.on('NodeChange', ({parents}) => {
        const userTag = parents.find(element => element.classList.contains('user-tag'));

        if (!userTag) return;

        editor.selection.setCursorLocation(userTag.nextSibling ?? userTag.previousSibling ?? userTag.parentElement, 0);
    });

    editor.on('PastePostProcess', ({node}) => {
        node.querySelectorAll('.user-tag').forEach(userTag => {
            userTag.outerHTML = userTag.innerText;
        });
    });

    return {
        getMetadata: () => ({
            name: 'action-tag',
            url: process.env.REACT_APP_HOST_API
        })
    };
}
